var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 40,
    viewBox: "0 0 158 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20916_34262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.052 36.2544C120.059 38.1194 118.554 39.6381 116.689 39.6468L37.4154 40.0006C35.5504 40.0081 34.0317 38.5031 34.023 36.6381C34.0155 34.7731 35.5205 33.2544 37.3855 33.2457L116.659 32.8919C118.524 32.8844 120.043 34.3894 120.052 36.2544Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0524 10.7677C88.5666 9.01853 87.8801 7.23699 87.0217 5.39066C87.1214 5.32463 87.2236 5.25985 87.3232 5.19382C86.4923 3.53811 85.6264 1.90233 84.5874 0.364968C82.9404 1.20964 81.3208 2.10415 79.756 3.09833C80.5172 4.75404 81.4716 6.37238 82.4919 7.92718C82.594 7.87486 82.6962 7.82502 82.7984 7.7727C84.4217 11.1875 85.7684 15.8519 83.1136 21.2402C81.0916 25.3402 76.0235 27.9664 71.2744 24.797C70.9779 24.574 70.6839 24.3273 70.3924 24.0545C66.8803 20.7805 67.9368 13.4774 69.9077 8.01314C70.1432 8.07045 70.1681 8.09412 70.3462 8.1315C70.9916 6.82836 71.9048 4.54225 72.3583 3.40231C72.3508 2.91145 72.3583 2.69468 72.2922 2.27732C70.5556 1.46629 68.7977 0.71131 66.9937 0.0634766C66.1204 1.73663 65.4015 3.54185 64.7774 5.35952C64.9107 5.42306 65.0402 5.48535 65.1735 5.54639C63.3272 9.38979 61.9867 14.2797 62.1387 19.6019C62.2483 23.3818 64.6304 27.2164 68.0988 29.5785C70.1631 31.1134 72.6573 32.1225 75.3072 32.2496C81.2386 32.5349 87.5363 29.4029 89.5956 22.4262C90.7754 18.4333 90.4067 14.7033 89.05 10.7639H89.0524V10.7677Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8123 2.06716C64.9295 6.14852 62.2958 12.6729 62.5076 20.0209C62.6782 25.9386 68.4278 31.9933 75.1877 32.3185C81.1191 32.6038 87.4168 29.4718 89.4761 22.4951C91.4458 15.8237 89.0986 9.88726 85.0347 2.48203C83.7752 2.55802 82.4721 2.57173 80.8188 3.66557C81.9501 6.51728 87.6547 13.1962 83.4862 21.6579C81.2698 26.1566 75.3808 28.8825 70.2729 24.1209C66.7608 20.8469 67.8173 13.5438 69.7882 8.07956C70.0237 8.13687 70.0486 8.16054 70.2268 8.19791C70.8721 6.89477 71.7853 4.60867 72.2388 3.46873C72.2313 2.97787 72.2388 2.76109 72.1727 2.34374C70.1557 2.52937 69.5291 2.20171 67.8186 2.06592H67.8136L67.8123 2.06716Z",
    fill: "url(#paint0_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3172 1.71484C64.4343 5.7962 61.8007 12.3231 62.0124 19.6686C62.1806 25.5863 67.9327 31.641 74.6925 31.9662C80.624 32.2515 86.9217 29.1195 88.981 22.1428C90.9507 15.4713 89.133 9.26584 85.0679 1.86061C83.8083 1.9366 81.9782 2.21941 80.325 3.31325C81.4562 6.16496 87.1609 12.8439 82.9898 21.3056C80.7735 25.8043 74.8844 28.5302 69.7765 23.7686C65.2354 19.5353 68.5805 8.50339 71.2715 3.51757C70.3745 2.47106 69.3143 1.87057 67.3209 1.71484H67.3185H67.3172Z",
    fill: "url(#paint1_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1491 3.60308C83.5823 3.69278 83.0241 3.83107 82.4884 4.03539C82.7426 4.49385 83.0104 4.94858 83.2359 5.36469C83.9934 6.76252 84.6761 8.17903 85.1881 9.68524C86.6184 13.8987 86.4315 18.0136 84.4506 22.0302C84.3148 22.3055 84.1678 22.5734 84.0121 22.835C82.8323 24.7947 81.037 26.3994 78.9066 27.2478C76.9469 28.0289 76.2941 30.6165 79.0188 29.879C80.2173 29.5538 81.3659 29.0605 82.4186 28.3989C84.9103 26.8329 86.5822 24.4957 87.4132 21.6839C89.3206 15.218 87.1715 9.28907 84.1504 3.60184V3.60433L84.1491 3.60308ZM72.8619 27.487C71.3407 27.0073 69.9155 26.139 68.6572 24.9666C65.195 21.7374 65.6348 15.9007 66.5667 11.701C67.1385 9.12213 68.0641 6.34641 69.2402 3.89959C68.8914 3.68406 68.5189 3.55325 68.104 3.46729C65.0791 8.14415 63.4845 14.1204 63.6414 19.627C63.7174 22.313 65.1576 24.8994 67.0301 26.7644C68.5176 28.2469 70.3752 29.3844 72.3947 29.9537C75.5142 30.8295 75.275 28.2507 72.8594 27.4882L72.8619 27.4857V27.487Z",
    fill: "url(#paint2_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1577 6.9619C83.7616 6.35269 83.024 3.82987 82.4896 4.0317C82.7437 4.49017 83.0116 4.94489 83.2371 5.361C83.9945 6.75883 84.6772 8.17534 85.1893 9.68156C86.6195 13.895 86.4326 18.01 84.4517 22.0265C84.316 22.3019 84.1689 22.5697 84.0132 22.8313C82.8334 24.791 81.0382 26.3957 78.9078 27.2441C77.8663 27.6589 77.1948 28.5846 77.2022 29.2486C77.4302 28.4912 77.9971 27.9268 79.0772 27.4721C81.1179 26.6112 84.5464 24.5107 85.8583 19.0826C86.9633 14.5104 86.1548 11.0345 84.1615 6.95567L84.159 6.96315L84.1577 6.9619ZM63.9428 18.3463C64.1285 15.7101 63.974 12.9892 66.7684 6.00635C67.4511 4.8228 68.5263 3.55081 68.1089 3.46484C65.084 8.14171 63.4893 14.118 63.6463 19.6246C63.7223 22.3106 65.1625 24.8969 67.035 26.7619C68.5225 28.2445 70.3801 29.3819 72.3996 29.9513C68.2572 28.5036 63.528 24.2279 63.9428 18.3463Z",
    fill: "url(#paint3_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7777 27.4001C71.1838 27.4001 71.5127 27.7253 71.5152 28.1315C71.5152 28.5376 71.1901 28.8665 70.7839 28.869C70.3778 28.869 70.0489 28.5438 70.0464 28.1377C70.0464 27.7315 70.3715 27.4026 70.7777 27.4001Z",
    fill: "url(#paint4_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7977 27.113C81.2039 27.113 81.5328 27.4382 81.5352 27.8443C81.5352 28.2505 81.2101 28.5794 80.8039 28.5819C80.3978 28.5819 80.0689 28.2567 80.0664 27.8506C80.0664 27.4444 80.3916 27.1155 80.7977 27.113Z",
    fill: "url(#paint5_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7892 23.8738C67.1691 23.8738 67.4769 24.1778 67.4769 24.5553C67.4769 24.9328 67.1729 25.2405 66.7941 25.243C66.4167 25.243 66.1089 24.939 66.1064 24.5603C66.1064 24.1828 66.4104 23.8751 66.7879 23.8726L66.7904 23.8751L66.7892 23.8738Z",
    fill: "url(#paint6_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3307 23.7957C84.7106 23.7957 85.0159 24.0997 85.0184 24.4772C85.0184 24.8546 84.7144 25.1624 84.3357 25.1649C83.9582 25.1649 83.6504 24.8609 83.6479 24.4821C83.6479 24.1046 83.9519 23.7969 84.3294 23.7944L84.3319 23.7969L84.3307 23.7957Z",
    fill: "url(#paint7_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8191 19.8596C65.1206 19.8596 65.3647 20.1013 65.3672 20.4028C65.3672 20.7043 65.1255 20.9485 64.824 20.951C64.5226 20.9535 64.2784 20.7093 64.2759 20.4078C64.2759 20.1063 64.5176 19.8621 64.8191 19.8596Z",
    fill: "url(#paint8_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5632 19.71C86.8647 19.71 87.1089 19.9517 87.1114 20.2531C87.1114 20.5546 86.8697 20.7988 86.5682 20.8013C86.2667 20.8038 86.0225 20.5596 86.02 20.2581C86.02 19.9566 86.2617 19.7125 86.5632 19.71Z",
    fill: "url(#paint9_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9055 15.9009C65.1995 15.9009 65.4374 16.1363 65.4399 16.4304C65.4399 16.7244 65.2045 16.9623 64.9104 16.9648C64.6164 16.9673 64.3785 16.7294 64.376 16.4353C64.376 16.1438 64.6114 15.9034 64.9055 15.9009Z",
    fill: "url(#paint10_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5218 11.5198C65.8046 11.5198 66.0338 11.7453 66.0363 12.0281C66.0363 12.3109 65.8083 12.5401 65.5267 12.5426C65.2452 12.5451 65.0147 12.3146 65.0122 12.0331C65.0122 11.7503 65.2402 11.521 65.5218 11.521V11.5198Z",
    fill: "url(#paint11_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.578 7.77588C66.8371 7.77588 67.0452 7.98269 67.0452 8.24058C67.0452 8.49846 66.8384 8.70776 66.5805 8.70776C66.3226 8.70776 66.1133 8.50095 66.1133 8.24556C66.1133 7.99016 66.3201 7.77837 66.578 7.77837V7.77588Z",
    fill: "url(#paint12_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1457 15.8013C87.4397 15.8013 87.6777 16.0367 87.6802 16.3307C87.6802 16.6248 87.4447 16.8627 87.1507 16.8652C86.8591 16.8652 86.6187 16.6298 86.6162 16.3357C86.6162 16.0442 86.8517 15.8038 87.1457 15.8013Z",
    fill: "url(#paint13_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6917 11.4604C86.9745 11.4604 87.2038 11.6884 87.2038 11.97C87.2038 12.2516 86.9783 12.482 86.6942 12.4845C86.4114 12.4845 86.1822 12.2565 86.1797 11.975C86.1797 11.6922 86.4077 11.4629 86.6892 11.4629L86.6917 11.4604Z",
    fill: "url(#paint14_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4427 7.71606C85.7018 7.71606 85.9099 7.92287 85.9124 8.18076C85.9124 8.4374 85.7055 8.64795 85.4477 8.64795C85.1898 8.64795 84.9805 8.44114 84.9805 8.18574C84.9805 7.93035 85.1873 7.71856 85.4452 7.71856L85.4427 7.71606Z",
    fill: "url(#paint15_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8677 0.130615C68.6704 0.778449 70.432 1.53342 72.1662 2.34446C71.5682 4.16961 70.7784 5.91253 69.9499 7.6405C68.1247 7.0425 66.3793 6.25514 64.6514 5.42666C65.2755 3.60898 65.9919 1.80377 66.8677 0.130615Z",
    fill: "url(#paint16_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9692 1.1349C66.426 2.27608 65.9389 3.4534 65.5053 4.64192C65.4131 4.89358 65.4916 5.22373 65.8093 5.37323C66.9368 5.9052 68.0705 6.42845 69.2503 6.82338C69.5107 6.91059 69.7586 6.77354 69.8246 6.63775C70.3865 5.46044 70.8325 4.23453 71.3508 3.03604C71.4505 2.80307 71.2798 2.53023 71.0618 2.43306C69.8782 1.90607 68.6909 1.39154 67.4812 0.935566C67.2819 0.85957 67.09 0.888224 66.9729 1.1349H66.9704H66.9692Z",
    fill: "url(#paint17_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6323 3.165C81.1958 2.17083 82.8142 1.27632 84.4637 0.431641C85.5027 1.969 86.3685 3.60353 87.1995 5.26049C85.6622 6.29952 84.0251 7.16537 82.3682 7.99385C81.3478 6.44154 80.3935 4.82445 79.6323 3.165Z",
    fill: "url(#paint18_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8248 1.37924C82.7758 1.9436 81.7555 2.5254 80.7028 3.14957C80.5084 3.26294 80.42 3.55073 80.5296 3.78245C81.0329 4.85013 81.6496 5.86548 82.2825 6.86464C82.4158 7.07394 82.741 7.20351 83.0437 7.04031C84.0329 6.51083 85.0246 5.98259 85.9814 5.3983C86.2281 5.2488 86.4299 4.9635 86.2355 4.58228C85.7235 3.5719 85.1679 2.58396 84.5773 1.61844C84.4141 1.35307 84.1313 1.21479 83.8224 1.38173L83.8248 1.37924Z",
    fill: "url(#paint19_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0734 22.4174L69.3496 25.8846L70.6876 18.4407L65.3081 13.1185L72.8068 12.0894L76.2067 5.33203L79.5044 12.1418L86.9831 13.2879L81.5239 18.5242L82.7448 25.9904L76.0734 22.4174Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7443 25.991L81.5221 18.5259L86.9813 13.2872L79.5026 12.141L76.2074 5.3313L72.805 12.0887L65.3101 13.119L70.6871 18.4412L69.3491 25.8863L76.0728 22.4179L82.743 25.991H82.7455H82.7443ZM70.717 24.0338L71.69 18.6219L71.7847 18.0949L71.4022 17.7174L67.4915 13.8478L72.942 13.1003L73.474 13.0268L73.7157 12.5472L76.1874 7.6336L78.5857 12.5858L78.8186 13.0704L79.3481 13.1514L84.7862 13.9836L80.817 17.7921L80.4307 18.1621L80.518 18.6916L81.4075 24.1185L76.5575 21.5222L76.0853 21.268L75.6081 21.5147L70.7182 24.0363L70.7157 24.0338H70.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2102 5.00488L72.7119 11.9517L72.9025 12.2232L72.9349 12.1535L76.2052 5.66019L76.2077 5.66518L76.2127 5.00488H76.2102Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6014 12.009L76.2115 5.00488L76.2065 5.66518L79.4071 12.2743L79.6039 12.009H79.6014Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2963 13.1883L79.6046 12.0085L79.4077 12.2739L86.6697 13.3877L87.2938 13.1908L87.2963 13.1883Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2941 13.1909L86.6699 13.3878L81.3677 18.472L81.3702 18.482L81.6804 18.5854V18.5767L87.2941 13.1909Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.554 25.7131V25.7206L76.0769 22.2522L76.0719 22.2572L76.0669 22.5836L76.0744 22.5823L82.9389 26.2576L82.9364 26.2501L82.554 25.7131Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6803 18.5858L81.3701 18.4824L82.5537 25.7132L82.9361 26.2502L81.6803 18.5858Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6227 13.2232L72.8261 12.2315L72.9021 12.2228L72.7115 11.9512V11.9537L64.9985 13.0151L65.0085 13.0238L65.6314 13.2331L65.6227 13.2232Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8458 18.3911L70.5294 18.4883L70.5319 18.4908L69.1577 26.1315L69.5502 25.607L70.8458 18.3911Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5449 25.6213L69.5499 25.6076L69.1575 26.1321L69.1562 26.1508L76.0669 22.584L76.0719 22.2576L69.5449 25.6213Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6312 13.2335L65.0083 13.0242L70.5286 18.4884L70.845 18.3912L65.6312 13.2335Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8053 13.9498L72.9656 13.2422L73.495 13.1687L73.5685 13.1599L73.3792 12.8921L72.9257 12.9556L67.1812 13.743L67.1911 13.7505L67.8128 13.9573L67.8053 13.9498Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.94 18.0454L67.8126 13.9578L67.1909 13.751L71.6298 18.145L71.6273 18.1475L71.94 18.0504V18.0454Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9407 18.0498L71.628 18.147L70.5229 24.2952L70.9141 23.7682L71.9407 18.0498Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9141 23.7708V23.7683L70.5229 24.2953V24.2965L76.0769 21.4336L76.0819 21.106L70.9141 23.7708Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1925 7.30469L73.585 12.4836L73.3806 12.8923H73.3794L73.5688 13.1601H73.5713L73.6061 13.0916L73.8466 12.6119L76.1875 7.96373L76.1925 7.30593V7.30469Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9196 12.9339L76.1925 7.30518L76.1875 7.96298L78.7215 13.1992L78.9196 12.9339Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2132 23.8399L81.2157 23.8498L76.0866 21.104L76.0816 21.1065L76.0767 21.4341L76.0841 21.4317L81.5982 24.3855V24.3756L81.2132 23.8399Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5891 18.2204L80.2764 18.1157L81.2132 23.8391L81.5982 24.3748L80.5891 18.2204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9194 12.9346L78.7251 13.1974L84.4597 14.0758L85.0913 13.8789C84.811 13.8366 79.0652 12.9557 78.9194 12.9346Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0905 13.8818L84.4589 14.0787H84.4751L80.2754 18.1102V18.1177L80.5881 18.2223V18.2148L85.1005 13.8843H85.088V13.8818H85.0905Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0566 5.86499C77.0516 6.33467 76.6679 6.71465 76.1982 6.70967C75.7286 6.70718 75.3486 6.32346 75.3536 5.85254C75.3561 5.38286 75.7423 5.00288 76.2119 5.00786C76.6816 5.01284 77.0616 5.39656 77.0566 5.86624V5.86375V5.86499Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4692 13.5672C87.4667 14.0368 87.0805 14.4168 86.6109 14.4118C86.1412 14.4069 85.7612 14.0231 85.7637 13.5535C85.7687 13.0838 86.1524 12.7038 86.6221 12.7088C87.0917 12.7138 87.4717 13.0975 87.4667 13.5672H87.4692Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3887 25.6595C83.3862 26.1291 83 26.5091 82.5303 26.5041C82.0606 26.5017 81.6806 26.1179 81.6831 25.6458C81.6881 25.1761 82.0718 24.7961 82.5415 24.7986C83.0112 24.8036 83.3912 25.1873 83.3862 25.657L83.3887 25.6595Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6806 25.4551C70.6782 25.9248 70.2919 26.3048 69.8223 26.2998C69.3526 26.2973 68.9726 25.9136 68.9776 25.4414C68.9801 24.9717 69.3663 24.5917 69.836 24.5967C70.3056 24.5992 70.6856 24.9854 70.6806 25.4551Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4145 13.2962C66.4096 13.7659 66.0258 14.1458 65.5562 14.1408C65.084 14.1384 64.7065 13.7546 64.709 13.2825C64.714 12.8128 65.0977 12.4328 65.5674 12.4378C66.0371 12.4428 66.417 12.8265 66.4121 13.2962H66.4145Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0756 22.0904L69.6808 25.3894L70.9528 18.3093L65.8398 13.25L72.9673 12.2707L76.2014 5.84473L79.336 12.3206L86.4484 13.4094L81.257 18.389L82.4182 25.489L76.0756 22.0904Z",
    fill: "url(#paint20_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4182 25.4883L81.2558 18.3895L86.4472 13.4087L79.3335 12.3198L76.199 5.84521L72.9648 12.27L65.8374 13.2505L70.9503 18.311L69.6783 25.3911L76.0732 22.0934L82.4157 25.4908L82.4182 25.4883ZM70.9815 23.6283L71.9071 18.4817L71.9968 17.9809L71.6343 17.6221L67.9167 13.9419L73.0981 13.2305L73.6039 13.162L73.8319 12.706L76.1828 8.03415L78.4627 12.7422L78.6857 13.2019L79.189 13.2779L84.3617 14.0702L80.5868 17.6906L80.2193 18.0444L80.3028 18.5477L81.1475 23.708L76.5354 21.2375L76.0869 20.9958L75.6334 21.2288L70.9852 23.627H70.9827L70.9815 23.6283Z",
    fill: "url(#paint21_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2043 5.53027L72.8779 12.1382L73.0598 12.3948L73.091 12.33L76.1993 6.15444L76.2018 6.15942L76.2068 5.53276L76.2043 5.53027Z",
    fill: "url(#paint22_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4309 12.1929L76.2066 5.53271L76.2017 6.15937L79.2427 12.4446H79.2452L79.4309 12.1929Z",
    fill: "url(#paint23_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.745 13.3136L79.4307 12.1924L79.2451 12.444L86.1495 13.5018L86.7438 13.3161L86.745 13.3136Z",
    fill: "url(#paint24_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7431 13.3167L86.1488 13.5023L81.1069 18.3399L81.1094 18.3473L81.4059 18.4445L81.4034 18.437L86.7431 13.3167Z",
    fill: "url(#paint25_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2343 25.2238L82.2367 25.2313L76.0773 21.9336L76.0699 21.9361L76.0674 22.2488L76.0724 22.2463L82.5993 25.7409L82.5968 25.7346L82.2343 25.2238Z",
    fill: "url(#paint26_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4059 18.4448L81.1094 18.3477L82.2344 25.2234L82.5969 25.7342L81.4059 18.4448Z",
    fill: "url(#paint27_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.136 13.3484L72.9856 12.4065L73.0566 12.3966L73.0591 12.3953L72.8772 12.1387V12.1412L65.543 13.149L65.5529 13.159L66.146 13.3559L66.136 13.3484Z",
    fill: "url(#paint28_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1029 18.2618V18.2593L70.8014 18.3527L70.8039 18.3552L69.4995 25.6222L69.8695 25.1213L71.1029 18.2618Z",
    fill: "url(#paint29_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8666 25.1366L69.8691 25.1216L69.4991 25.6225L69.4966 25.6387L76.0684 22.2487L76.0708 21.936L69.8666 25.1366Z",
    fill: "url(#paint30_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1458 13.3553L65.5527 13.1584L70.8002 18.3523L71.1017 18.2589L66.1458 13.3553Z",
    fill: "url(#paint31_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2112 14.0376L73.1185 13.3636L73.6218 13.2951L73.6904 13.2864L73.5097 13.0322L73.0799 13.0908L67.6182 13.8408L67.6256 13.8482L68.2187 14.0451L68.2112 14.0376Z",
    fill: "url(#paint32_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1463 17.9307L68.2195 14.0462L67.6265 13.8494L71.8474 18.0254V18.0304L72.1439 17.9369L72.1463 17.9307Z",
    fill: "url(#paint33_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1439 17.9363L71.8474 18.0297L70.7959 23.8727L71.1672 23.3756L72.1439 17.9363Z",
    fill: "url(#paint34_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1672 23.3758L70.7959 23.8729V23.8779L76.0782 21.1545L76.0807 20.8418L71.1672 23.3758Z",
    fill: "url(#paint35_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1863 7.72021L73.7096 12.6438L73.5127 13.0325H73.5103L73.6909 13.2866H73.6934L73.727 13.2193L73.9563 12.7671L76.1826 8.34438V8.34562L76.1863 7.72021Z",
    fill: "url(#paint36_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7812 13.0723L76.1873 7.72021L76.1836 8.34562L78.5943 13.324L78.7812 13.0723Z",
    fill: "url(#paint37_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9601 23.4414L80.9626 23.4501L76.0851 20.8389L76.0801 20.8414L76.0776 21.1541L76.0826 21.1516L81.3263 23.9584V23.951L80.9601 23.4414Z",
    fill: "url(#paint38_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3673 18.0984L80.0708 17.9988L80.9603 23.4418L81.3266 23.9514L80.3673 18.0984Z",
    fill: "url(#paint39_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7799 13.0725L78.5942 13.3242L84.0485 14.1589L84.649 13.972C84.3836 13.9321 78.9194 13.0937 78.7811 13.0725H78.7786H78.7799Z",
    fill: "url(#paint40_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.648 13.9714L84.0475 14.1583H84.0637L80.0708 17.9905V17.998L80.3698 18.0976V18.0902L84.6617 13.9739H84.6492L84.6468 13.9714H84.648Z",
    fill: "url(#paint41_linear_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0076 5.98503C77.0026 6.43104 76.6376 6.79233 76.1915 6.78735C75.743 6.78486 75.3842 6.41983 75.3867 5.97133C75.3892 5.52283 75.7543 5.16403 76.2028 5.16652C76.6488 5.16901 77.0101 5.53653 77.0076 5.98254V5.98503Z",
    fill: "url(#paint42_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28 13.4899C87.2775 13.9384 86.91 14.2972 86.464 14.2947C86.0155 14.2897 85.6555 13.9247 85.6592 13.4786C85.6642 13.0301 86.0292 12.6713 86.4752 12.6738C86.9212 12.6788 87.2825 13.0439 87.28 13.4899Z",
    fill: "url(#paint43_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.217 25.5394C83.2146 25.9879 82.847 26.3467 82.401 26.3442C81.9525 26.3417 81.5925 25.9767 81.5962 25.5282C81.5987 25.0822 81.9662 24.7209 82.4122 24.7234C82.8607 24.7284 83.2195 25.0934 83.217 25.5394Z",
    fill: "url(#paint44_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5784 25.3503C70.5759 25.7988 70.2083 26.1576 69.7623 26.1526C69.3138 26.1501 68.955 25.7851 68.9575 25.3366C68.96 24.8881 69.3275 24.5293 69.7736 24.5318C70.2196 24.5342 70.5809 24.9018 70.5784 25.3478V25.3503Z",
    fill: "url(#paint45_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5188 13.236C66.5138 13.6845 66.1488 14.0445 65.7028 14.0408C65.2543 14.0383 64.8955 13.6708 64.898 13.2247C64.9005 12.7762 65.268 12.4174 65.714 12.4199C66.1625 12.4249 66.5213 12.7899 66.5188 13.236Z",
    fill: "url(#paint46_radial_20916_34262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.381886 14.3404L4.14306 13.33C7.63762 12.3906 9.69325 13.0671 10.3099 15.3582C10.7298 16.9143 10.1791 18.1987 8.65796 19.2016L13.3062 23.2755L10.2601 24.094L6.00558 20.3852C5.71655 20.4749 5.4001 20.5658 5.05625 20.658L6.27094 25.1667L3.49523 25.9142L0.379395 14.3404H0.381886ZM4.48442 18.5189L6.02178 18.1065C6.51513 17.9732 6.92127 17.744 7.24145 17.4163C7.62392 17.0202 7.74975 16.5767 7.61644 16.087C7.38596 15.2299 6.57244 14.9882 5.17959 15.3632L3.73941 15.7494L4.48442 18.5189Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.107142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1053 12.0819C21.9043 12.0744 23.4703 12.6163 24.8008 13.7077C26.2622 14.9062 26.9985 16.4647 27.0072 18.382C27.0172 20.2894 26.2958 21.8392 24.8432 23.0352C23.5338 24.1166 21.979 24.6611 20.1813 24.6698C18.3661 24.6772 16.7901 24.1478 15.4546 23.0776C13.9646 21.8891 13.2171 20.3305 13.2071 18.4032C13.2021 17.2234 13.5136 16.152 14.139 15.1815C14.737 14.2446 15.5717 13.4946 16.6394 12.934C17.707 12.3721 18.8632 12.0893 20.1078 12.0844L20.1028 12.0819H20.1053ZM20.0916 14.3144C18.908 14.3194 17.9064 14.6744 17.0879 15.3796C16.1884 16.1508 15.7424 17.1686 15.7473 18.4356C15.7523 19.7026 16.288 20.8039 17.3507 21.5776C18.1792 22.1781 19.1186 22.4746 20.1676 22.4696C21.3137 22.4646 22.3029 22.1046 23.1289 21.3882C24.0334 20.6071 24.4819 19.6042 24.4769 18.3796C24.4719 17.1387 24.0072 16.1346 23.0866 15.3684C22.2419 14.6595 21.2427 14.3082 20.0903 14.3132L20.0928 14.3156L20.0916 14.3144Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0718 12.3428L33.8408 12.3217C34.6332 12.3192 35.2 12.3528 35.5377 12.4288C35.803 12.5185 36.1543 12.6356 36.5916 12.7751C37.8873 13.1875 38.9189 13.9475 39.69 15.05C40.3615 16.0131 40.7004 17.148 40.7079 18.4524C40.7178 20.3436 40.0202 21.8361 38.6174 22.9349C37.46 23.8419 35.8205 24.2991 33.7013 24.3091L29.1291 24.3303L29.0768 12.3441H29.0718V12.3428ZM31.86 14.5305L31.8936 22.0828L34.4039 22.0703C34.6818 22.0703 35.0829 21.9844 35.6087 21.8211C36.396 21.572 36.9891 21.1098 37.3877 20.4283C37.8885 19.5674 38.1402 18.8934 38.1377 18.4038C38.1253 15.8013 36.8346 14.5081 34.2657 14.5168L31.8624 14.5293H31.86V14.5305Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8179 12.2817L50.8062 12.2456L50.8161 14.4781L45.5911 14.5018L45.6036 16.915L49.6064 16.8963L49.6164 19.0952L45.6135 19.1139L45.626 22.0154L50.851 21.9918L50.861 24.2318L42.8727 24.2679L42.8204 12.2817H42.8179Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0682 11.9061C60.8672 11.8986 62.4332 12.4405 63.7637 13.5319C65.2251 14.7304 65.9614 16.2889 65.9701 18.2063C65.9801 20.1136 65.2587 21.6635 63.8061 22.8595C62.4967 23.9408 60.9419 24.4853 59.1442 24.494C57.329 24.5015 55.753 23.972 54.4175 22.9018C52.9274 21.7133 52.1799 20.1547 52.17 18.2274C52.165 17.0476 52.4765 15.9762 53.1019 15.0057C53.6999 14.0688 54.5346 13.3189 55.6023 12.7582C56.6699 12.1964 57.8261 11.9136 59.0707 11.9086L59.0657 11.9061H59.0682ZM59.0545 14.1386C57.8709 14.1436 56.8693 14.4987 56.0508 15.2038C55.1513 15.975 54.7053 16.9928 54.7102 18.2598C54.7152 19.5269 55.2509 20.6282 56.3136 21.4018C57.1421 22.0023 58.0815 22.2988 59.1305 22.2938C60.2766 22.2889 61.2658 21.9288 62.0918 21.2125C62.9963 20.4313 63.4448 19.4284 63.4398 18.2038C63.4348 16.9629 62.9701 15.9588 62.0494 15.1926C61.2048 14.4837 60.2056 14.1324 59.0532 14.1374L59.0557 14.1399L59.0545 14.1386Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.065918 14.1866L3.82709 13.1762C7.31916 12.2368 9.37728 12.9133 9.99397 15.2044C10.4138 16.763 9.86316 18.0449 8.34199 19.0478L12.9902 23.1217L9.94414 23.9402L5.68961 20.2314C5.40058 20.3211 5.08414 20.412 4.74278 20.5042L5.95747 25.0129L3.18175 25.7604L0.065918 14.1866ZM4.16845 18.3651L5.70581 17.9527C6.19916 17.8194 6.6053 17.5902 6.92548 17.2625C7.30795 16.8664 7.43378 16.4228 7.30048 15.9332C7.07 15.0761 6.25647 14.8344 4.86363 15.2094L3.42344 15.5956L4.16845 18.3651Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.107142
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9139 11.7579C21.7129 11.7504 23.2789 12.2924 24.6094 13.3837C26.0708 14.5822 26.8071 16.1407 26.8158 18.0581C26.8258 19.9654 26.1044 21.5153 24.6518 22.7113C23.3424 23.7926 21.7876 24.3371 19.9899 24.3458C18.1747 24.3533 16.5987 23.8238 15.2632 22.7536C13.7732 21.5651 13.0257 20.0066 13.0157 18.0793C13.0107 16.8994 13.3222 15.828 13.9476 14.8575C14.5456 13.9207 15.3803 13.1707 16.448 12.61C17.5156 12.0482 18.6718 11.7654 19.9164 11.7579H19.9114H19.9139ZM19.9002 13.9904C18.7166 13.9954 17.715 14.3505 16.8965 15.0556C15.997 15.8268 15.551 16.8446 15.5559 18.1116C15.5609 19.4335 16.0966 20.48 17.1593 21.2536C17.9878 21.8541 18.9272 22.1506 19.9762 22.1457C21.1223 22.1407 22.1115 21.7806 22.9375 21.0643C23.842 20.2831 24.2905 19.2802 24.2855 18.0556C24.2805 16.8147 23.8158 15.8106 22.8951 15.0444C22.0505 14.3355 21.0513 13.9842 19.8989 13.9892L19.9014 13.9917L19.9002 13.9904Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6221 11.9592L50.6104 11.9231L50.6203 14.1556L45.3953 14.1793L45.4078 16.5925L49.4106 16.5738L49.4206 18.7727L45.4177 18.7914L45.4302 21.6929L50.6552 21.6693L50.6652 23.9093L42.6769 23.9454L42.6246 11.9592H42.6221Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8714 11.5845C60.6704 11.5771 62.2364 12.119 63.5669 13.2104C65.0283 14.4089 65.7646 15.9674 65.7733 17.8847C65.7833 19.7921 65.0619 21.3419 63.6093 22.5379C62.2999 23.6193 60.7451 24.1637 58.9474 24.1725C57.1322 24.1799 55.5562 23.6505 54.2207 22.5803C52.7307 21.3918 51.9832 19.8332 51.9732 17.9059C51.9682 16.7261 52.2797 15.6547 52.9051 14.6842C53.5031 13.7473 54.3378 12.9973 55.4055 12.4367C56.4732 11.8748 57.6293 11.592 58.8739 11.5845H58.8689H58.8714ZM58.8577 13.8171C57.6741 13.8221 56.6725 14.1771 55.854 14.8823C54.9545 15.6534 54.5085 16.6713 54.5135 17.9383C54.5184 19.2601 55.0542 20.3066 56.1168 21.0803C56.9453 21.6808 57.8847 21.9773 58.9337 21.9723C60.0798 21.9673 61.069 21.6073 61.895 20.8909C62.7995 20.1098 63.248 19.1069 63.243 17.8822C63.238 16.6414 62.7733 15.6372 61.8527 14.8711C61.008 14.1622 60.0088 13.8109 58.8564 13.8158L58.8589 13.8183L58.8577 13.8171Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8999 12.0591C30.0174 12.0542 31.1349 12.0492 32.2524 12.0454C33.6976 12.038 35.1727 11.9906 36.5493 12.5101C37.7266 12.9561 38.7943 13.7298 39.5181 14.7663C40.1897 15.7294 40.5285 16.8643 40.536 18.1687C40.546 20.0599 39.8483 21.5524 38.4455 22.6512C37.2881 23.5582 35.6486 24.0154 33.5294 24.0254L28.9572 24.0466L28.9049 12.0604H28.8999V12.0591ZM31.6881 14.2468L31.7217 21.7991C33.4235 21.7916 35.2686 22.0383 36.6453 20.8211C38.0568 19.5728 38.3844 17.2455 37.3591 15.6584C36.6477 14.5595 35.3334 14.2294 34.0925 14.2344L31.6893 14.2468H31.6881Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.418 11.9984L93.187 11.9772C93.9794 11.9747 94.5462 12.0083 94.8839 12.0843C95.1492 12.174 95.5005 12.2911 95.9378 12.4307C97.2335 12.843 98.265 13.603 99.0362 14.7056C99.7077 15.6686 100.047 16.8035 100.054 18.1079C100.064 19.9991 99.3664 21.4916 97.9636 22.5904C96.8062 23.4974 95.1667 23.9546 93.0475 23.9646L88.4753 23.9858L88.423 11.9996H88.418V11.9984ZM91.2061 14.186L91.2398 21.7383L93.7501 21.7258C94.028 21.7258 94.4291 21.6399 94.9549 21.4767C95.7422 21.2275 96.3352 20.7653 96.7339 20.0838C97.2347 19.223 97.4864 18.549 97.4839 18.0593C97.4714 15.4568 96.1808 14.1636 93.6119 14.1723L91.2086 14.1848H91.2061V14.186Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.163 11.9368L110.151 11.9006L110.161 14.1332L104.936 14.1568L104.948 16.57L108.951 16.5513L108.961 18.7502L104.958 18.7689L104.971 21.6705L110.196 21.6468L110.206 23.8868L102.217 23.9229L102.165 11.9368H102.163Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.239 11.8924L114.902 11.88L121.218 19.7412L121.182 11.8525L123.97 11.8401L124.022 23.8263L121.341 23.8387L115.046 16.0037L115.082 23.8661L112.294 23.8786L112.242 11.8924H112.239Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.675 11.8331L134.822 11.7932L134.832 14.0419L131.678 14.0556L131.721 23.7931L128.893 23.8055L128.85 14.0681L125.687 14.0818L125.677 11.8331H125.675Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.851 11.7683L142.672 11.7559L148.349 23.7171L145.455 23.7296L144.301 21.0224L138.331 21.0485L137.157 23.7682L134.264 23.7806L139.851 11.7696H139.849L139.851 11.7683ZM141.291 14.6063L139.36 18.7375L143.254 18.7213L141.291 14.6076V14.6063Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.961 11.7239L152.732 11.7114L152.774 21.262L157.6 21.2408L157.61 23.6204L150.013 23.7101L149.961 11.7239Z",
    fill: "#3B2314",
    stroke: "#754C28",
    strokeWidth: 0.10465,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.222 11.6739C89.3395 11.6689 90.457 11.6639 91.5745 11.6602C93.0197 11.6527 94.4598 11.5966 95.8352 12.1137C97.0263 12.5622 98.1064 13.3333 98.8389 14.3848C99.5104 15.3478 99.8493 16.4828 99.8568 17.7872C99.8668 19.6784 99.1691 21.1709 97.7663 22.2697C96.6089 23.1767 94.9694 23.6339 92.8502 23.6438L88.278 23.665L88.2257 11.6789L88.2207 11.6764L88.222 11.6739ZM91.0101 13.8616L91.0438 21.4138C92.7456 21.4063 94.5907 21.653 95.9673 20.4358C97.3788 19.1875 97.7065 16.8603 96.6812 15.2731C95.9698 14.1743 94.6554 13.8441 93.4146 13.8491L91.0114 13.8616H91.0101Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.967 11.6147L109.956 11.5786L109.966 13.8111L104.741 13.8348L104.753 16.248L108.756 16.2293L108.766 18.4282L104.763 18.4469L104.775 21.3484L110 21.3248L110.01 23.5648L102.022 23.6009L101.97 11.6147H101.967Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.043 11.5701L114.705 11.5577L121.022 19.4189L120.986 11.5303L123.774 11.5178L123.826 23.504L121.145 23.5164L114.85 15.6814L114.886 23.5439L112.098 23.5563L112.045 11.5701H112.043Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.482 11.5079L134.629 11.468L134.639 13.7167L131.486 13.7305L131.528 23.4679L128.7 23.4803L128.658 13.7429L125.494 13.7566L125.484 11.5079H125.482Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.655 11.4463L142.476 11.4338L148.153 23.3951L145.259 23.4075L144.105 20.7004L138.135 20.7265L136.96 23.4462L134.067 23.4586L139.655 11.4475H139.652L139.655 11.4463ZM141.095 14.2843L139.164 18.4155L143.057 18.3993L141.095 14.2856V14.2843Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.764 11.4019L152.535 11.3894L152.577 20.94L157.404 20.9188L157.414 23.2983L149.816 23.388L149.764 11.4019Z",
    fill: "#F5EA14",
    stroke: "#DD1F26",
    strokeWidth: 0.10465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4336 38.2576V35.3582H51.4133C51.6398 35.3582 51.8257 35.3969 51.9711 35.4743C52.1164 35.5508 52.224 35.656 52.2939 35.79C52.3637 35.9241 52.3986 36.0765 52.3986 36.2473C52.3986 36.4181 52.3637 36.5696 52.2939 36.7018C52.224 36.8339 52.1169 36.9377 51.9725 37.0132C51.8281 37.0878 51.6436 37.1251 51.4189 37.1251H50.6261V36.8079H51.4076C51.5624 36.8079 51.687 36.7853 51.7814 36.74C51.8767 36.6947 51.9456 36.6305 51.9881 36.5474C52.0315 36.4634 52.0532 36.3634 52.0532 36.2473C52.0532 36.1312 52.0315 36.0298 51.9881 35.9429C51.9446 35.8561 51.8753 35.7891 51.7799 35.7419C51.6846 35.6938 51.5586 35.6697 51.4019 35.6697H50.7847V38.2576H50.4336ZM51.7983 36.9552L52.5119 38.2576H52.1041L51.4019 36.9552H51.7983Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.822 36.8079C57.822 37.1137 57.7668 37.378 57.6564 37.6007C57.546 37.8235 57.3945 37.9953 57.2019 38.1161C57.0094 38.2369 56.7895 38.2973 56.5422 38.2973C56.2949 38.2973 56.075 38.2369 55.8825 38.1161C55.69 37.9953 55.5385 37.8235 55.428 37.6007C55.3176 37.378 55.2624 37.1137 55.2624 36.8079C55.2624 36.5021 55.3176 36.2379 55.428 36.0151C55.5385 35.7924 55.69 35.6206 55.8825 35.4998C56.075 35.379 56.2949 35.3186 56.5422 35.3186C56.7895 35.3186 57.0094 35.379 57.2019 35.4998C57.3945 35.6206 57.546 35.7924 57.6564 36.0151C57.7668 36.2379 57.822 36.5021 57.822 36.8079ZM57.4823 36.8079C57.4823 36.5569 57.4403 36.345 57.3563 36.1723C57.2732 35.9996 57.1604 35.8688 57.0179 35.7801C56.8763 35.6914 56.7178 35.6471 56.5422 35.6471C56.3667 35.6471 56.2076 35.6914 56.0651 35.7801C55.9235 35.8688 55.8108 35.9996 55.7268 36.1723C55.6437 36.345 55.6022 36.5569 55.6022 36.8079C55.6022 37.059 55.6437 37.2709 55.7268 37.4436C55.8108 37.6163 55.9235 37.747 56.0651 37.8358C56.2076 37.9245 56.3667 37.9688 56.5422 37.9688C56.7178 37.9688 56.8763 37.9245 57.0179 37.8358C57.1604 37.747 57.2732 37.6163 57.3563 37.4436C57.4403 37.2709 57.4823 37.059 57.4823 36.8079Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7071 35.3582H63.0582V37.278C63.0582 37.4762 63.0115 37.6531 62.9181 37.8089C62.8256 37.9636 62.6948 38.0859 62.5259 38.1755C62.357 38.2642 62.1588 38.3086 61.9313 38.3086C61.7038 38.3086 61.5056 38.2642 61.3367 38.1755C61.1678 38.0859 61.0366 37.9636 60.9431 37.8089C60.8506 37.6531 60.8044 37.4762 60.8044 37.278V35.3582H61.1555V37.2496C61.1555 37.3912 61.1866 37.5172 61.2489 37.6276C61.3112 37.7371 61.3999 37.8235 61.5151 37.8867C61.6312 37.949 61.7699 37.9802 61.9313 37.9802C62.0927 37.9802 62.2314 37.949 62.3475 37.8867C62.4636 37.8235 62.5523 37.7371 62.6137 37.6276C62.676 37.5172 62.7071 37.3912 62.7071 37.2496V35.3582Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4505 35.3582V38.2576H68.1107L66.5308 35.9812H66.5024V38.2576H66.1513V35.3582H66.4911L68.0767 37.6404H68.105V35.3582H68.4505Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4398 38.2576H71.545V35.3582H72.4794C72.7607 35.3582 73.0013 35.4163 73.2014 35.5324C73.4015 35.6475 73.5549 35.8132 73.6615 36.0293C73.7682 36.2445 73.8215 36.5021 73.8215 36.8023C73.8215 37.1043 73.7677 37.3643 73.6601 37.5823C73.5525 37.7994 73.3958 37.9665 73.1901 38.0835C72.9843 38.1996 72.7342 38.2576 72.4398 38.2576ZM71.8961 37.9462H72.4171C72.6568 37.9462 72.8555 37.8999 73.0131 37.8074C73.1707 37.7149 73.2883 37.5833 73.3656 37.4125C73.443 37.2416 73.4817 37.0382 73.4817 36.8023C73.4817 36.5682 73.4435 36.3667 73.3671 36.1978C73.2906 36.0279 73.1764 35.8976 73.0245 35.807C72.8725 35.7155 72.6833 35.6697 72.4568 35.6697H71.8961V37.9462Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7052 35.3582H79.0563V37.278C79.0563 37.4762 79.0096 37.6531 78.9161 37.8089C78.8236 37.9636 78.6929 38.0859 78.524 38.1755C78.355 38.2642 78.1568 38.3086 77.9294 38.3086C77.7019 38.3086 77.5037 38.2642 77.3348 38.1755C77.1658 38.0859 77.0346 37.9636 76.9412 37.8089C76.8487 37.6531 76.8024 37.4762 76.8024 37.278V35.3582H77.1535V37.2496C77.1535 37.3912 77.1847 37.5172 77.247 37.6276C77.3093 37.7371 77.398 37.8235 77.5131 37.8867C77.6292 37.949 77.768 37.9802 77.9294 37.9802C78.0908 37.9802 78.2295 37.949 78.3456 37.8867C78.4617 37.8235 78.5504 37.7371 78.6117 37.6276C78.674 37.5172 78.7052 37.3912 78.7052 37.2496V35.3582Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1494 38.2576V35.3582H83.1291C83.3566 35.3582 83.5425 35.3993 83.6869 35.4814C83.8322 35.5626 83.9398 35.6725 84.0097 35.8113C84.0795 35.95 84.1144 36.1048 84.1144 36.2756C84.1144 36.4465 84.0795 36.6017 84.0097 36.7414C83.9408 36.8811 83.8341 36.9925 83.6897 37.0755C83.5453 37.1576 83.3603 37.1987 83.1348 37.1987H82.4326V36.8872H83.1234C83.2792 36.8872 83.4042 36.8603 83.4986 36.8065C83.593 36.7527 83.6614 36.6801 83.7039 36.5885C83.7473 36.496 83.769 36.3917 83.769 36.2756C83.769 36.1595 83.7473 36.0557 83.7039 35.9642C83.6614 35.8726 83.5925 35.8009 83.4972 35.749C83.4019 35.6961 83.2754 35.6697 83.1178 35.6697H82.5005V38.2576H82.1494Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5853 38.2576V35.3582H91.5649C91.7924 35.3582 91.9783 35.3993 92.1227 35.4814C92.2681 35.5626 92.3757 35.6725 92.4455 35.8113C92.5154 35.95 92.5503 36.1048 92.5503 36.2756C92.5503 36.4465 92.5154 36.6017 92.4455 36.7414C92.3766 36.8811 92.27 36.9925 92.1256 37.0755C91.9812 37.1576 91.7962 37.1987 91.5706 37.1987H90.8684V36.8872H91.5593C91.715 36.8872 91.8401 36.8603 91.9345 36.8065C92.0288 36.7527 92.0973 36.6801 92.1397 36.5885C92.1831 36.496 92.2049 36.3917 92.2049 36.2756C92.2049 36.1595 92.1831 36.0557 92.1397 35.9642C92.0973 35.8726 92.0284 35.8009 91.933 35.749C91.8377 35.6961 91.7112 35.6697 91.5536 35.6697H90.9364V38.2576H90.5853Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5079 38.2576V35.3582H95.859V37.9462H97.2067V38.2576H95.5079Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.444 38.2576H100.076L101.141 35.3582H101.503L102.568 38.2576H102.2L101.333 35.8169H101.311L100.444 38.2576ZM100.58 37.1251H102.064V37.4365H100.58V37.1251Z",
    fill: "#F5EA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.711 35.3582V38.2576H107.371L105.791 35.9812H105.763V38.2576H105.411V35.3582H105.751L107.337 37.6404H107.365V35.3582H107.711Z",
    fill: "#F5EA14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20916_34262",
    x1: 62.4867,
    y1: 17.2436,
    x2: 90.1813,
    y2: 17.1227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B77228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A26224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#80481E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#512415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#391211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3B1311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#431A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#512514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#653517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7F491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9F621F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C47F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20916_34262",
    x1: 73.1153,
    y1: 5.15386,
    x2: 78.9821,
    y2: 31.1565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EEBA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EFC063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F5D888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FAE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FDF4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#BF782A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20916_34262",
    x1: 70.9392,
    y1: 3.08101,
    x2: 82.6206,
    y2: 36.0664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F4CD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDE782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F8D369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F4C153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F1BC4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBB044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E09C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DA9027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20916_34262",
    x1: 69.7155,
    y1: 6.81929,
    x2: 82.4813,
    y2: 29.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B5825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A46026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BD7629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A76625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6B381A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.3919 28.9597) rotate(-0.25) scale(1.26178 1.26178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.7651 59.633) scale(1.48752 1.48753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9417 56.0051) scale(1.14368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2781 56.1425) scale(1.32183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8371 51.5449) scale(0.975489 0.975487)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4371 51.5447) scale(1.01785 1.01785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0218 47.489) scale(1.12001 1.12)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6244 42.7653) scale(1.01287 1.01286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6297 38.8482) scale(0.865852 0.865855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.2339 47.4779) scale(1.23836 1.23836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.679 42.8916) scale(1.11003 1.11004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.3851 38.8009) scale(0.98919 0.989192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_20916_34262",
    x1: 66.6048,
    y1: 8.00707,
    x2: 70.0536,
    y2: 0.0808994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EEBB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F0CE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DB7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F3E286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.1959 3.98727) rotate(-0.25) scale(5.66665 5.66665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9A5C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#77411C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5C2C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#481D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_20916_34262",
    x1: 81.742,
    y1: 1.52569,
    x2: 85.4883,
    y2: 7.53052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EEBB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F0CE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F2DB7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F3E286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BF782A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.5178 4.30569) rotate(-0.25) scale(5.27077 5.27078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9A5C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#77411C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5C2C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#481D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.602 9.49332) rotate(-179.55) scale(19.2197 19.2197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7544 6.25653) rotate(-0.15) scale(29.8527 29.8527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_20916_34262",
    x1: 74.5164,
    y1: 8.86063,
    x2: 78.6863,
    y2: 12.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_20916_34262",
    x1: 75.2312,
    y1: 3.81045,
    x2: 79.9055,
    y2: 13.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_20916_34262",
    x1: 81.1283,
    y1: 8.82973,
    x2: 84.6208,
    y2: 16.4022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_20916_34262",
    x1: 79.6441,
    y1: 10.3734,
    x2: 84.6596,
    y2: 16.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_20916_34262",
    x1: 80.952,
    y1: 17.6803,
    x2: 79.5971,
    y2: 22.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_20916_34262",
    x1: 78.2059,
    y1: 19.7738,
    x2: 84.2134,
    y2: 23.4378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_20916_34262",
    x1: 69.3143,
    y1: 12.8133,
    x2: 70.6215,
    y2: 16.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_20916_34262",
    x1: 68.0506,
    y1: 19.6542,
    x2: 73.7276,
    y2: 25.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_20916_34262",
    x1: 69.4447,
    y1: 20.3918,
    x2: 71.9822,
    y2: 22.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_20916_34262",
    x1: 68.3701,
    y1: 10.2326,
    x2: 68.3269,
    y2: 15.7228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_20916_34262",
    x1: 68.0768,
    y1: 10.9101,
    x2: 71.1557,
    y2: 14.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_20916_34262",
    x1: 66.8505,
    y1: 12.8041,
    x2: 72.9477,
    y2: 19.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_20916_34262",
    x1: 69.1613,
    y1: 18.5588,
    x2: 74.8395,
    y2: 24.3269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_20916_34262",
    x1: 72.9349,
    y1: 21.7432,
    x2: 76.0878,
    y2: 25.6003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_20916_34262",
    x1: 72.917,
    y1: 8.12772,
    x2: 75.8414,
    y2: 11.5631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_20916_34262",
    x1: 74.4639,
    y1: 5.77894,
    x2: 79.771,
    y2: 14.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_20916_34262",
    x1: 72.6317,
    y1: 18.3965,
    x2: 82.1071,
    y2: 24.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_20916_34262",
    x1: 78.3654,
    y1: 19.5121,
    x2: 84.3742,
    y2: 23.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_20916_34262",
    x1: 79.938,
    y1: 9.44638,
    x2: 81.9506,
    y2: 14.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_20916_34262",
    x1: 81.9758,
    y1: 15.5629,
    x2: 85.4534,
    y2: 19.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.035 5.65318) rotate(0.45) scale(1.42085 1.42085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.3893 -12.6739) scale(1.48254 1.48254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.2478 -0.056257) scale(1.48254 1.48254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0535 -0.150703) scale(1.48254 1.48254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_20916_34262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.7186 -12.7683) scale(1.48254 1.48254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20916_34262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.664,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.34e15522f99f4e481d6aeca91eb0882e.svg";
export { ForwardRef as ReactComponent };